import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.deferred_view.title',
        defaultMessage: 'Your application is on hold'
    },
    subtitle: {
        id: '_.deferred_view.subtitle',
        defaultMessage:
            "If you'd like to re-apply for this application, click on the button beneath. We may require you to submit additional documents."
    },
    underButtonText: {
        id: '_.deferred_view.underButtonText',
        defaultMessage:
            'Or, give us a call on { link } if you have any questions.'
    },
    callPhoneNumber: {
        id: '_.deferred_view.callPhoneNumber',
        defaultMessage: '+442033973375'
    },
    displayPhoneNumber: {
        id: '_.deferred_view.displayPhoneNumber',
        defaultMessage: '020 3397 3375'
    },
    reApplyButtonText: {
        id: '_.deferred_view.reApplyButtonText',
        defaultMessage: 'Re-apply'
    }
});
